export class EnumeratorList {

    constructor() {}

    modeOfPaymentEnum: { value: string, viewValue: string }[] = [
        { value: 'Cash', viewValue: 'Cash' },
        { value: 'Online via PhonePe', viewValue: 'Online via PhonePe' },
        { value: 'Cheque', viewValue: 'Cheque' },
        { value: 'DD', viewValue: 'DD' },
        { value: 'NEFT', viewValue: 'NEFT' },
        { value: 'RTGS', viewValue: 'RTGS' }
    ];
    
    salutationEnum: { value: string, viewValue: string }[] = [
        { value: 'Shri.', viewValue: 'Shri' },
        { value: 'Shrimati', viewValue: 'Shrimati' },
        { value: 'Mr.', viewValue: 'Mr.' },
        { value: 'Miss.', viewValue: 'Miss.' },
        { value: 'From', viewValue: 'From' }
    ];

    entityTypeEnum: { value: string, viewValue: string }[] = [
        { value: 'C', viewValue: 'Credit' },
        { value: 'D', viewValue: 'Debit' }
    ];
}  